import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { useSelector } from "react-redux";

const TCPopup = ({ open, handleClose, handleSubmit }) => {
  const trainingCentreRegReducer = (globalState) =>
    globalState.trainingCentreRegReducer;

  const { registeringTrainingCentre } = useSelector(trainingCentreRegReducer);

  return (
    <Dialog
      sx={{
        "& .MuiDialog-paper": {
          width: "80%",
          maxHeight: 435,
          padding: "0 10px",
        },
      }}
      maxWidth="sm"
      open={open}
    >
      <DialogTitle>Terms and Conditions</DialogTitle>
      <DialogContent dividers>
        <ol>
          {/* <li>
            You accept that if invited as an in-camp orientation trainer,
            training is free and at no cost to Corps members.
          </li>
          <li>
            You accept that post-camp training is at a cost negotiable between
            you and NYSC.
          </li>
          <li>
            You accept that for any Corps member that registered for post-camp
            training, you will ensure completion of the agreed training modules
            or curriculum.
          </li>
          <li>
            You accept that training schedules will not interfere with the
            primary assignment of the Corps member(s) and as agreed together
            with the NYSC Local Government Inspector and the trainee.
          </li>
          <li>
            You accept to protect trainee Corps member(s) from
            training/occupational hazards.
          </li>
          <li>
            You agree to provide a conducive environment for training of Corps
            members including the provision of rest rooms/conveniences.
          </li>
          <li>
            You agree to allow periodic inspection or monitoring of your
            training facility by NYSC officials.
          </li>
          <li>
            You accept not to arrest trainee Corps member with security agency
            or use physical assault but rather follow NYSC procedure of
            disciplining erring Corps member by reporting to the NYSC Local
            Government Inspector in cases of misconduct and indiscipline.
          </li>
          <li>
            You agree not to embark on journeys or tour with trainee Corps
            member(s) outside the location of your facility without permission
            from the NYSC state Coordinator.
          </li>
          <li>
            You agree not to collude with Corps member(s) to falsify training
            that was never undertaken.
          </li>
          <li>You agree not to falsify record of training in your facility.</li>
          <li>
            You agree that your accreditation should be revoked if your conduct
            is in violation of the agreed terms and conditions and the
            requirements for accreditation of your Centre or for any other
            reason as decided by NYSC Management.
          </li> */}
          <li>	I agree that I have the necessary skill, competence and expertise to provide and or carryout the service of a professional trainer.</li>
        <li>	I accept that if invited as an in-camp orientation trainer, I will offer my service at no cost to the corps members.</li>  
        <li>	I accept that I will offer post-camp training at a negotiable cost to be agreed between NYSC and me. </li>
        <li>	I accept that I will ensure completion of the agreed training modules, curriculum or schedules for any corps member who registered for post-camp training.</li>
        <li>	I accept that the schedules for training will not interfere with corps member/trainee primary assignment as stipulated by NYSC and agreed by the corps member.</li>
        <li>	I agree to protect corps member/trainee from training/occupational hazards.</li>
        <li>	I agree to provide a conducive training environment for training of corps members including the provision of conveniences.</li>
        <li>	I agree to permit periodic inspection of my training facility and the monitoring of the training by NYSC officials.</li>
        <li>	I agree not to assault, arrest, harass, intimidate, or coerce corps member/trainee, but shall follow established NYSC procedure for reporting or dealing with cases of indiscipline or misconduct involving corps member/trainee.</li>  
        <li>	I agree not to allow, permit, encourage or embark on travels or tours with corps member/trainee outside the location of my facility, unless approved by the NYSC State Coordinator.</li>
        <li>	I agree not to allow, facilitate or collude with corps member/trainee with intent to perpetrate any illegality or falsify training that was never undertaken or falsify records of such training at my facility.</li>
        <li>	I agree that if I am engaged as a trainer or my facility is approved for training, I cannot disengage or discontinue providing the service until the completion of the agreed term which for this purpose is two (2) years, except by a six (6) months written notice to NYSC.</li>
        <li>	I agree to grant NYSC free access, right and license to use, reproduce, modify, adapt, create, translate and publish, derivative words from my works or contents, and distribute, perform and display such content in whole or part in Nigeria and the world, in any form or media or technology developed or later developed, and to enjoy the rights and privileges with respect to such works.</li>
        <li>	I agree that all prospective trainers sponsored by me are deemed to have met quality control requirements suitable for the purpose of training.</li>
        <li>	I agree that trainers will only be permitted to carryout training on behalf of NYSC only upon successful completion of the application form, registration and approval by NYSC.</li>
        <li>	I agree to periodically upload training evaluation forms as required by NYSC from time to time and agree to allow NYSC investigate any unsatisfactory evaluation form, conduct, trainer or training which leads to or may lead to corps members dissatisfaction.  </li> 
        <li>	I agree that where the cause of NYSC’s dissatisfaction is related to poor quality of trainers or lack of knowledge, such trainer(s) will be asked to withdraw from providing training forthwith.</li>
        <li>	I agree to submit standard training curriculum at no cost to NYSC but retain all the rights to it. </li>
        <li>	I agree that where NYSC or other trainer makes amendments or changes to the curriculum and I do not object to it, NYSC and or trainer will own the copyright to such amendment or changes.  I agree not to produce or use the modified outlines without written permission from NYSC.</li>
        <li>	I agree to abide by all applicable Nigerian legislation, principles and guidelines on personal data protection and privacy including the Nigerian Data Protection Act 2023, Nigerian Data Protection Regulations 2019 and such other applicable legislation as well as the data privacy policy. </li>
        <li>	l agree that the accreditation of my facility should be revoked if my conduct or the operations of the facility is in violation of the terms and conditions agreed herein. </li>
        <li>	I agree that it's my responsibility as a trainer and or proprietor of my training facility to notify NYSC of any reason(s) that may or do constrain me by law or for any other reason from engaging in agreed services for NYSC at any time.</li>
        <li>	I agree that NYSC shall have no liability at any time for any direct or indirect losses arising out of the negligence or other action(s) of trainer acting on its behalf including liability for death, personal injury, or loss of property in violation of the terms and conditions herein contained or any other causes of action that may be connected to the conduct of the trainer.</li>
        </ol>

        
      </DialogContent>
      <DialogActions>
        <Button disabled={registeringTrainingCentre} onClick={handleClose}>
          Back
        </Button>
        <Button
          autoFocus
          variant="contained"
          onClick={handleSubmit}
          disabled={registeringTrainingCentre}
        >
          {registeringTrainingCentre ? (
            <CircularProgress />
          ) : (
            <> Agree & Submit</>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TCPopup;
